
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as mh6Rr4C3smV1bw3mr_2I2rMY7FQIyKpJVaEb3LCEKNq4Meta } from "/nuxtWeb/pages/v/m.vue?macro=true";
import { default as indexs0dizR8Z1uJZRzbKRf4wJpfEab0mFix51iXhKJjApiEMeta } from "/nuxtWeb/pages/index.vue?macro=true";
import { default as loginhV4ttJ10YYb9Ynp67J1kXUuMTzS8V5Pjv5PZbHrl66UMeta } from "/nuxtWeb/pages/login.vue?macro=true";
import { default as indexkikXjWYVB6PqPRmDI4o3eIvrhjD0Os_lZcPPNojniPUMeta } from "/nuxtWeb/pages/v/index.vue?macro=true";
import { default as indexVv9wjvK6HWFqgogvZmU47YqrS3hhsYmb_Euzb_45lVu_45MMeta } from "/nuxtWeb/pages/h5/index.vue?macro=true";
import { default as _91_46_46_46slug_933lZ3OjMm7CAYVymlweEIGiHie09EtY7cKnzuN_zxnQwMeta } from "/nuxtWeb/pages/[...slug].vue?macro=true";
import { default as pcZ_EP__IMET6WcF9Y0WyeJdgG6ruwbQdoEy2_tZEcO28Meta } from "/nuxtWeb/pages/detail/pc.vue?macro=true";
import { default as indexRghymR98fKeSpRh4vH7flLqiNodPDPyOpqEDBXbA_45KYMeta } from "/nuxtWeb/pages/shop/index.vue?macro=true";
import { default as help_45centervcasDtNIg0Zvk6xqLZyeDOdXRgeNkAbYUTg6z2t7nZ0Meta } from "/nuxtWeb/pages/help-center.vue?macro=true";
import { default as webAZabJredTJt_vlKY3O32hc05T5Cdu3JUXalrcBnTuZYMeta } from "/nuxtWeb/pages/preview/web.vue?macro=true";
import { default as indexf4ew68tovwv_Hp4ndNcnjK3SEjXCed_GVJg002Xb1jEMeta } from "/nuxtWeb/pages/detail/index.vue?macro=true";
import { default as indexqR1iWf7s7bXIgm683mS_45zCyF0HvLSbKde6LLXF9DsHAMeta } from "/nuxtWeb/pages/preview/index.vue?macro=true";
import { default as indexyB1eGXy85Ygs_8WxnvYHj9GYw_S_45CfxC1a6ba2ahpiEMeta } from "/nuxtWeb/pages/product/index.vue?macro=true";
import { default as _91_46_46_46path_9370PuiE8XGLKByJI_tv4_45A7SCimPD4gYDcsLdYSug1owMeta } from "/nuxtWeb/pages/sub/[...path].vue?macro=true";
import { default as indexBKGWIEdAQ73bNySCFth4__45raTaVRaOutFVBxv1ICdRQMeta } from "/nuxtWeb/pages/tb/shop/index.vue?macro=true";
import { default as _91_46_46_46path_93jnqsssuPsAX2_45MbQER1Q2TUSHeeNAHEP05S3KmySEs0Meta } from "/nuxtWeb/pages/mall/[...path].vue?macro=true";
import { default as search2pjgIQ1llPYH9GFL9lXDYDQTBgw8vic_PTWN6JeeiwwMeta } from "/nuxtWeb/pages/product/search.vue?macro=true";
import { default as not_45foundpO_45Chu_Z64PTqb4Bd8poWtMpJWdwSIefpl_Kg9zYaZIMeta } from "/nuxtWeb/pages/error/not-found.vue?macro=true";
import { default as pickupPointqi905WaR9koBir2jFcD6vSuxJgbQCqKVDiGwvSn5h_oMeta } from "/nuxtWeb/pages/shop/pickupPoint.vue?macro=true";
import { default as _91itemId_93L1aNEqSYQ6VmripckK6SlDTJRUS6_45p0zcuUIey9FC2gMeta } from "/nuxtWeb/pages/tb/goods/[itemId].vue?macro=true";
import { default as _91itemId_93viXbpkVrQ6b1nldeMP1OgO5fYYeG_45Z9ZqAtaORg_45dxgMeta } from "/nuxtWeb/pages/wd/goods/[itemId].vue?macro=true";
import { default as _91_46_46_46path_93dnHw9plnR3E15JtAEQzOJMXubbQCK5ubdNpeNxjo5UAMeta } from "/nuxtWeb/pages/collection/[...path].vue?macro=true";
import { default as estimationR09W2qZC55fo_453IEtbXTHBqL6_yNu_45VMHtevbuYVZ9QMeta } from "/nuxtWeb/pages/collection/estimation.vue?macro=true";
import { default as checkSendPackageH_45GI4greZg0mOIaZf8mV0Ogdn2k1_45kbwxno4St4gODgMeta } from "/nuxtWeb/pages/shop/checkSendPackage.vue?macro=true";
import { default as warehouseAddresshVrmrsHPPEwboUPmsD6nGd7pk_GVE5AntITY4DgfB3gMeta } from "/nuxtWeb/pages/shop/warehouseAddress.vue?macro=true";
import { default as _91itemId_93_32copyozINAyLixSwU_nwWPT_HUuTq6u3SOzDtRpAoKMkKPnoMeta } from "/nuxtWeb/pages/tb/goods/[itemId] copy.vue?macro=true";
import { default as _91itemId_93_32copyOvfsQHvVo51Ru4qRyBAUahVz5oFz7r_4526xXNLRdGKp4Meta } from "/nuxtWeb/pages/wd/goods/[itemId] copy.vue?macro=true";
import { default as expertPurchaseHomehvUE_45iwArXQSno5eXYA7fHEB83wzza_28CZbmeoUFVEMeta } from "/nuxtWeb/pages/shop/expertPurchaseHome.vue?macro=true";
import { default as tbPayOrderPqLezfB1U6AbjsdKk8c_45h7vD6eyvaBV2lqmhDKM4MjAMeta } from "/nuxtWeb/pages/user-center/mall/tbPayOrder.vue?macro=true";
import { default as browseHistoryRN7P9LjSuFhK9ox2aFcZGzq0QctZGofi4zFRm8VCz4QMeta } from "/nuxtWeb/pages/user-center/mall/browseHistory.vue?macro=true";
import { default as direct_45payment_45confirm95H_O__9XOu8CzlHi7qvwEKndICqV6Z6Sk_45NCA8d2uEMeta } from "/nuxtWeb/pages/tb/order/direct-payment-confirm.vue?macro=true";
import { default as myPackageJCX4_455ACzKSyjGAoaPRB1uKfFbr2z_sbFTqjkGvH1wUMeta } from "/nuxtWeb/pages/user-center/collection/myPackage.vue?macro=true";
import { default as PayWeidianOrderaL1n2KGu1wd9spfhMKXZozLthvHeb5a5bWW2BrQjsYYMeta } from "/nuxtWeb/pages/user-center/mall/PayWeidianOrder.vue?macro=true";
import { default as refundOrderListcimedVG4eJFpVj8slcPRLtFQB1lT0zuwPll0VFkpgwEMeta } from "/nuxtWeb/pages/user-center/mall/refundOrderList.vue?macro=true";
import { default as myWarehouseC_45_45wMYCEfLGO0MUbBsmZVRduQ54rYBnuxR0Itb_49SkMeta } from "/nuxtWeb/pages/user-center/collection/myWarehouse.vue?macro=true";
import { default as expertPurchaseHomemE4O693MzdtAKA17ovLpuTL_45WRHwWO5LhrQFzEREYQoMeta } from "/nuxtWeb/pages/user-center/mall/expertPurchaseHome.vue?macro=true";
import { default as tbDirectPaymentConfirmNKVSP0NEixxKV6G6I4FBLeUt9NGZ59q_W_jwqy04w1AMeta } from "/nuxtWeb/pages/user-center/mall/tbDirectPaymentConfirm.vue?macro=true";
import { default as Homeyx3yNDTbejMZUCSnDDX4Npvi_AcOQap8mNq1V4ZuHMkMeta } from "/nuxtWeb/user-center/entry/Home.vue?macro=true";
import { default as Page2_457zcb3SGXF_Z8AREhVvq1TgaNvRPUw6ckCSXFK1PdsMeta } from "/nuxtWeb/user-center/entry/Page.vue?macro=true";
export default [
  {
    name: "v-m",
    path: "/v/m",
    component: () => import("/nuxtWeb/pages/v/m.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/nuxtWeb/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhV4ttJ10YYb9Ynp67J1kXUuMTzS8V5Pjv5PZbHrl66UMeta || {},
    component: () => import("/nuxtWeb/pages/login.vue")
  },
  {
    name: "v",
    path: "/v",
    component: () => import("/nuxtWeb/pages/v/index.vue")
  },
  {
    name: "h5",
    path: "/h5",
    meta: indexVv9wjvK6HWFqgogvZmU47YqrS3hhsYmb_Euzb_45lVu_45MMeta || {},
    component: () => import("/nuxtWeb/pages/h5/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/nuxtWeb/pages/[...slug].vue")
  },
  {
    name: "detail-pc",
    path: "/detail/pc",
    component: () => import("/nuxtWeb/pages/detail/pc.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/nuxtWeb/pages/shop/index.vue")
  },
  {
    name: "help-center",
    path: "/help-center",
    meta: help_45centervcasDtNIg0Zvk6xqLZyeDOdXRgeNkAbYUTg6z2t7nZ0Meta || {},
    component: () => import("/nuxtWeb/pages/help-center.vue")
  },
  {
    name: "preview-web",
    path: "/preview/web",
    component: () => import("/nuxtWeb/pages/preview/web.vue")
  },
  {
    name: "detail",
    path: "/detail",
    component: () => import("/nuxtWeb/pages/detail/index.vue")
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/nuxtWeb/pages/preview/index.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/nuxtWeb/pages/product/index.vue")
  },
  {
    name: "sub-path",
    path: "/sub/:path(.*)*",
    meta: _91_46_46_46path_9370PuiE8XGLKByJI_tv4_45A7SCimPD4gYDcsLdYSug1owMeta || {},
    component: () => import("/nuxtWeb/pages/sub/[...path].vue")
  },
  {
    name: "tb-shop",
    path: "/tb/shop",
    component: () => import("/nuxtWeb/pages/tb/shop/index.vue")
  },
  {
    name: "mall-path",
    path: "/mall/:path(.*)*",
    meta: _91_46_46_46path_93jnqsssuPsAX2_45MbQER1Q2TUSHeeNAHEP05S3KmySEs0Meta || {},
    component: () => import("/nuxtWeb/pages/mall/[...path].vue")
  },
  {
    name: "product-search",
    path: "/product/search",
    component: () => import("/nuxtWeb/pages/product/search.vue")
  },
  {
    name: "error-not-found",
    path: "/error/not-found",
    component: () => import("/nuxtWeb/pages/error/not-found.vue")
  },
  {
    name: "shop-pickupPoint",
    path: "/shop/pickupPoint",
    meta: pickupPointqi905WaR9koBir2jFcD6vSuxJgbQCqKVDiGwvSn5h_oMeta || {},
    component: () => import("/nuxtWeb/pages/shop/pickupPoint.vue")
  },
  {
    name: "tb-goods-itemId",
    path: "/tb/goods/:itemId()",
    component: () => import("/nuxtWeb/pages/tb/goods/[itemId].vue")
  },
  {
    name: "wd-goods-itemId",
    path: "/wd/goods/:itemId()",
    component: () => import("/nuxtWeb/pages/wd/goods/[itemId].vue")
  },
  {
    name: "collection-path",
    path: "/collection/:path(.*)*",
    meta: _91_46_46_46path_93dnHw9plnR3E15JtAEQzOJMXubbQCK5ubdNpeNxjo5UAMeta || {},
    component: () => import("/nuxtWeb/pages/collection/[...path].vue")
  },
  {
    name: "collection-estimation",
    path: "/collection/estimation",
    meta: estimationR09W2qZC55fo_453IEtbXTHBqL6_yNu_45VMHtevbuYVZ9QMeta || {},
    component: () => import("/nuxtWeb/pages/collection/estimation.vue")
  },
  {
    name: "shop-checkSendPackage",
    path: "/shop/checkSendPackage",
    meta: checkSendPackageH_45GI4greZg0mOIaZf8mV0Ogdn2k1_45kbwxno4St4gODgMeta || {},
    component: () => import("/nuxtWeb/pages/shop/checkSendPackage.vue")
  },
  {
    name: "shop-warehouseAddress",
    path: "/shop/warehouseAddress",
    meta: warehouseAddresshVrmrsHPPEwboUPmsD6nGd7pk_GVE5AntITY4DgfB3gMeta || {},
    component: () => import("/nuxtWeb/pages/shop/warehouseAddress.vue")
  },
  {
    name: "tb-goods-itemId copy",
    path: "/tb/goods/:itemId()%20copy",
    component: () => import("/nuxtWeb/pages/tb/goods/[itemId] copy.vue")
  },
  {
    name: "wd-goods-itemId copy",
    path: "/wd/goods/:itemId()%20copy",
    component: () => import("/nuxtWeb/pages/wd/goods/[itemId] copy.vue")
  },
  {
    name: "shop-expertPurchaseHome",
    path: "/shop/expertPurchaseHome",
    meta: expertPurchaseHomehvUE_45iwArXQSno5eXYA7fHEB83wzza_28CZbmeoUFVEMeta || {},
    component: () => import("/nuxtWeb/pages/shop/expertPurchaseHome.vue")
  },
  {
    name: "user-center-mall-tbPayOrder",
    path: "/user-center/mall/tbPayOrder",
    meta: tbPayOrderPqLezfB1U6AbjsdKk8c_45h7vD6eyvaBV2lqmhDKM4MjAMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/tbPayOrder.vue")
  },
  {
    name: "user-center-mall-browseHistory",
    path: "/user-center/mall/browseHistory",
    meta: browseHistoryRN7P9LjSuFhK9ox2aFcZGzq0QctZGofi4zFRm8VCz4QMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/browseHistory.vue")
  },
  {
    name: "tb-order-direct-payment-confirm",
    path: "/tb/order/direct-payment-confirm",
    component: () => import("/nuxtWeb/pages/tb/order/direct-payment-confirm.vue")
  },
  {
    name: "user-center-collection-myPackage",
    path: "/user-center/collection/myPackage",
    meta: myPackageJCX4_455ACzKSyjGAoaPRB1uKfFbr2z_sbFTqjkGvH1wUMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/collection/myPackage.vue")
  },
  {
    name: "user-center-mall-PayWeidianOrder",
    path: "/user-center/mall/PayWeidianOrder",
    meta: PayWeidianOrderaL1n2KGu1wd9spfhMKXZozLthvHeb5a5bWW2BrQjsYYMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/PayWeidianOrder.vue")
  },
  {
    name: "user-center-mall-refundOrderList",
    path: "/user-center/mall/refundOrderList",
    meta: refundOrderListcimedVG4eJFpVj8slcPRLtFQB1lT0zuwPll0VFkpgwEMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/refundOrderList.vue")
  },
  {
    name: "user-center-collection-myWarehouse",
    path: "/user-center/collection/myWarehouse",
    meta: myWarehouseC_45_45wMYCEfLGO0MUbBsmZVRduQ54rYBnuxR0Itb_49SkMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/collection/myWarehouse.vue")
  },
  {
    name: "user-center-mall-expertPurchaseHome",
    path: "/user-center/mall/expertPurchaseHome",
    meta: expertPurchaseHomemE4O693MzdtAKA17ovLpuTL_45WRHwWO5LhrQFzEREYQoMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/expertPurchaseHome.vue")
  },
  {
    name: "user-center-mall-tbDirectPaymentConfirm",
    path: "/user-center/mall/tbDirectPaymentConfirm",
    meta: tbDirectPaymentConfirmNKVSP0NEixxKV6G6I4FBLeUt9NGZ59q_W_jwqy04w1AMeta || {},
    component: () => import("/nuxtWeb/pages/user-center/mall/tbDirectPaymentConfirm.vue")
  },
  {
    name: "userCenterRoot",
    path: "/user-center",
    meta: Homeyx3yNDTbejMZUCSnDDX4Npvi_AcOQap8mNq1V4ZuHMkMeta || {},
    component: () => import("/nuxtWeb/user-center/entry/Home.vue")
  },
  {
    name: "UserCenterLogin",
    path: "/user-center/login",
    meta: { ...(Page2_457zcb3SGXF_Z8AREhVvq1TgaNvRPUw6ckCSXFK1PdsMeta || {}), ...{"userCenterViewKey":"login","userCenterStandalone":true,"requiresUserCenterAuth":false,"title":"登入","pageTitle":"登入"} },
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallHome",
    path: "/user-center/mall/home",
    meta: {"userCenterViewKey":"mallHome","requiresUserCenterAuth":true,"code":"mallHome","title":"首頁","pageTitle":"首頁"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallCetnerHome",
    path: "/user-center/mall/mallCenterHome",
    meta: {"userCenterViewKey":"mallHome1","requiresUserCenterAuth":true,"code":"mallHome1","title":"首頁","pageTitle":"首頁"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallExpertPurchaseHome",
    path: "/user-center/mall/expertPurchaseHome",
    meta: {"userCenterViewKey":"mallExpertPurchaseHome","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallExpertPurchaseHome","title":"專家代購","pageTitle":"專家代購"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallExpertPurchaseOrders",
    path: "/user-center/mall/expertPurchaseOrders",
    meta: {"userCenterViewKey":"mallExpertPurchaseOrders","requiresUserCenterAuth":true,"code":"mallExpertPurchaseOrders","title":"代購訂單","pageTitle":"代購訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAllOrderList",
    path: "/user-center/mall/platformAllOrderList",
    meta: {"userCenterViewKey":"mallAllOrderList","requiresUserCenterAuth":true,"code":"mallAllOrderList","title":"全部訂單","pageTitle":"全部訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAlibabaOrderListV2",
    path: "/user-center/mall/platformAllOrderListV2",
    meta: {"userCenterViewKey":"mallAlibabaOrderListV2","requiresUserCenterAuth":true,"code":"mallAlibabaOrderListV2","title":"我的訂單","pageTitle":"我的訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallRefundOrderList",
    path: "/user-center/mall/refundOrderList",
    meta: {"userCenterViewKey":"mallRefundOrderList","requiresUserCenterAuth":true,"code":"mallRefundOrderList","title":"退款/售後","pageTitle":"退款/售後"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallSelectOrderList",
    path: "/user-center/mall/selectOrderList",
    meta: {"userCenterViewKey":"mallSelectOrderList","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallSelectOrderList","title":"全部訂單","pageTitle":"全部訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallWarehousePackage",
    path: "/user-center/mall/warehousePackage",
    meta: {"userCenterViewKey":"mallWarehousePackage","requiresUserCenterAuth":true,"code":"mallWarehousePackage","title":"倉庫包裹","pageTitle":"倉庫包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallFavorites",
    path: "/user-center/mall/favorites",
    meta: {"userCenterViewKey":"mallFavorites","requiresUserCenterAuth":true,"code":"mallFavorites","title":"收藏夾","pageTitle":"收藏夾"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallBrowseHistory",
    path: "/user-center/mall/browseHistory",
    meta: {"userCenterViewKey":"mallBrowseHistory","requiresUserCenterAuth":true,"code":"mallBrowseHistory","title":"瀏覽記錄","pageTitle":"瀏覽記錄"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAccount",
    path: "/user-center/mall/account",
    meta: {"userCenterViewKey":"mallAccount","requiresUserCenterAuth":true,"code":"mallAccount","title":"會員中心","pageTitle":"會員中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallMessage",
    path: "/user-center/mall/message",
    meta: {"userCenterViewKey":"mallMessage","requiresUserCenterAuth":true,"code":"mallMessage","title":"訊息中心","pageTitle":"訊息中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallNotices",
    path: "/user-center/mall/notices",
    meta: {"userCenterViewKey":"mallNotices","requiresUserCenterAuth":true,"code":"mallNotices","title":"消息公告","pageTitle":"消息公告"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallAllOrderDetail",
    path: "/user-center/mall/allOrderDetail",
    meta: {"userCenterViewKey":"mallAllOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallAllOrderDetail","title":"訂單詳情","pageTitle":"訂單詳情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbOrderDetail",
    path: "/user-center/mall/tbOrderDetail",
    meta: {"userCenterViewKey":"mallTbOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbOrderDetail","title":"訂單詳情","pageTitle":"訂單詳情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallWeidianOrderDetail",
    path: "/user-center/mall/weidianOrderDetail",
    meta: {"userCenterViewKey":"mallWeidianOrderDetail","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallWeidianOrderDetail","title":"訂單詳情","pageTitle":"訂單詳情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallUnifiedOrderDetail",
    path: "/user-center/mall/unifiedOrderDetail",
    meta: {"userCenterViewKey":"mallUnifiedOrderDetail","requiresUserCenterAuth":true,"code":"mallUnifiedOrderDetail","title":"訂單詳情","pageTitle":"訂單詳情"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallCart",
    path: "/user-center/mall/cart",
    meta: {"userCenterViewKey":"mallCart","requiresUserCenterAuth":true,"code":"mallCart","title":"購物車","pageTitle":"購物車"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallConfirmation1688Order",
    path: "/user-center/mall/confirmation1688Order",
    meta: {"userCenterViewKey":"mallConfirmation1688Order","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallConfirmation1688Order","title":"確認訂單","pageTitle":"確認訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallConfirmationWeidianOrder",
    path: "/user-center/mall/confirmationWeidianOrder",
    meta: {"userCenterViewKey":"mallConfirmationWeidianOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallConfirmationWeidianOrder","title":"確認訂單","pageTitle":"確認訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPay1688Order",
    path: "/user-center/mall/Pay1688Order",
    meta: {"userCenterViewKey":"mallPay1688Order","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallPay1688Order","title":"支付訂單","pageTitle":"支付訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPayWeidianOrder",
    path: "/user-center/mall/PayWeidianOrder",
    meta: {"userCenterViewKey":"mallPayWeidianOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallPayWeidianOrder","title":"支付訂單","pageTitle":"支付訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbDirectPaymentConfirm",
    path: "/user-center/mall/tbDirectPaymentConfirm",
    meta: {"userCenterViewKey":"mallTbDirectPaymentConfirm","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbDirectPaymentConfirm","title":"確認訂單","pageTitle":"確認訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallTbPayOrder",
    path: "/user-center/mall/tbPayOrder",
    meta: {"userCenterViewKey":"mallTbPayOrder","requiresUserCenterAuth":true,"hiddenSider":true,"code":"mallTbPayOrder","title":"支付訂單","pageTitle":"支付訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mall1688Recharge",
    path: "/user-center/mall/recharge",
    meta: {"userCenterViewKey":"mallRecharge","requiresUserCenterAuth":true,"code":"mall1688Recharge","title":"餘額充值","pageTitle":"餘額充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallGoldRecharge",
    path: "/user-center/mall/recharge/gold",
    meta: {"userCenterViewKey":"mallGoldRecharge","requiresUserCenterAuth":true,"code":"mallGoldRecharge","title":"購物金幣充值","pageTitle":"購物金幣充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "mallPackage",
    path: "/user-center/collection/mallPackage",
    meta: {"userCenterViewKey":"collectionMallPackage","requiresUserCenterAuth":true,"code":"mallPackage","title":"電商包裹","pageTitle":"電商包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionMyWarehouse",
    path: "/user-center/collection/myWarehouse",
    meta: {"userCenterViewKey":"collectionMyWarehouse","requiresUserCenterAuth":true,"code":"CollectionMyWarehouse","title":"我的倉庫","pageTitle":"我的倉庫"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionMyPackage",
    path: "/user-center/collection/myPackage",
    meta: {"userCenterViewKey":"collectionMyPackage","requiresUserCenterAuth":true,"code":"CollectionMyPackage","title":"我的包裹","pageTitle":"我的包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionHome",
    path: "/user-center/collection/home",
    meta: {"userCenterViewKey":"collectionHome","requiresUserCenterAuth":true,"code":"collectionHome","title":"首頁","pageTitle":"首頁"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionOrder",
    path: "/user-center/collection/order",
    meta: {"userCenterViewKey":"collectionOrder","requiresUserCenterAuth":true,"code":"collectionOrder","title":"集運訂單","pageTitle":"集運訂單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPackage",
    path: "/user-center/collection/package",
    meta: {"userCenterViewKey":"collectionPackage","requiresUserCenterAuth":true,"code":"collectionPackage","title":"集運包裹","pageTitle":"集運包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionForecast",
    path: "/user-center/collection/forecast",
    meta: {"userCenterViewKey":"collectionForecast","requiresUserCenterAuth":true,"code":"collectionForecast","title":"申請預報","pageTitle":"申請預報"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionIncome",
    path: "/user-center/collection/income",
    meta: {"userCenterViewKey":"collectionIncome","requiresUserCenterAuth":true,"code":"collectionIncome","title":"消費流水","pageTitle":"消費流水"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionAddress",
    path: "/user-center/collection/address",
    meta: {"userCenterViewKey":"collectionAddress","requiresUserCenterAuth":true,"code":"collectionAddress","title":"收貨地址","pageTitle":"收貨地址"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionInvite",
    path: "/user-center/collection/invite",
    meta: {"userCenterViewKey":"collectionInvite","requiresUserCenterAuth":true,"code":"collectionInvite","title":"賺取積分","pageTitle":"賺取積分"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "FindLogistics",
    path: "/user-center/collection/findLogistics",
    meta: {"userCenterViewKey":"collectionFindLogistics","requiresUserCenterAuth":true,"code":"FindLogistics","title":"物流查詢","pageTitle":"物流查詢"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionRechargeWallet",
    path: "/user-center/collection/rechargeWallet",
    meta: {"userCenterViewKey":"collectionRechargeWallet","requiresUserCenterAuth":true,"code":"collectionRechargeWallet","title":"快捷充值","pageTitle":"快捷充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionRecharge",
    path: "/user-center/collection/recharge",
    meta: {"userCenterViewKey":"collectionRecharge","requiresUserCenterAuth":true,"code":"collectionRecharge","title":"快捷充值","pageTitle":"快捷充值"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionCoupons",
    path: "/user-center/collection/coupons",
    meta: {"userCenterViewKey":"collectionCoupons","requiresUserCenterAuth":true,"code":"collectionCoupons","title":"優惠券","pageTitle":"優惠券"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionFeedback",
    path: "/user-center/collection/feedback",
    meta: {"userCenterViewKey":"collectionFeedback","requiresUserCenterAuth":true,"code":"collectionFeedback","title":"問題反饋","pageTitle":"問題反饋"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPoints",
    path: "/user-center/collection/points",
    meta: {"userCenterViewKey":"collectionPoints","requiresUserCenterAuth":true,"code":"collectionPoints","title":"積分","pageTitle":"積分"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionPayOrder",
    path: "/user-center/collection/payOrder",
    meta: {"userCenterViewKey":"collectionPayOrder","requiresUserCenterAuth":true,"code":"collectionPayOrder","title":"應付帳單","pageTitle":"應付帳單"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionDeclaration",
    path: "/user-center/collection/declaration",
    meta: {"userCenterViewKey":"collectionDeclaration","requiresUserCenterAuth":true,"code":"collectionDeclaration","title":"發起集運","pageTitle":"發起集運"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionProxy",
    path: "/user-center/collection/proxy",
    meta: {"userCenterViewKey":"collectionProxy","requiresUserCenterAuth":true,"code":"collectionProxy","title":"代理中心","pageTitle":"代理中心"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "WithdrawCash",
    path: "/user-center/collection/withdrawCash",
    meta: {"userCenterViewKey":"collectionWithdrawCash","requiresUserCenterAuth":true,"code":"withdrawCash","title":"代理提現","pageTitle":"代理提現"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  },
  {
    name: "CollectionReturnPackage",
    path: "/user-center/collection/ReturnPackage",
    meta: {"userCenterViewKey":"collectionReturnPackage","requiresUserCenterAuth":true,"title":"退貨包裹","pageTitle":"退貨包裹"},
    component: () => import("/nuxtWeb/user-center/entry/Page.vue")
  }
]